import { BaseAPIResponse, GetCompanyListAPIResponse } from 'types';
import { baseApi } from './axios';
import { API_ENDPOINT } from 'src/config/env.config';

const baseUrl = `${API_ENDPOINT}/auth`;
export const signout = async (): Promise<BaseAPIResponse> => {
	const response = await baseApi.post(`${baseUrl}/signout`);
	return response.data;
};

export const searchCompanies = async (q: string): Promise<GetCompanyListAPIResponse> => {
	const response = await baseApi.get(`${API_ENDPOINT}/company/companies`, {
		params: {
			company: q,
		},
	});
	return response.data;
};

export const autoLoginLMSUser = async (args: { token: string }): Promise<BaseAPIResponse> => {
	const response = await baseApi.post(`${baseUrl}/auto-login-lms-user`, {
		token: args?.token,
	});
	return response.data;
};
